import React from "react";
import { ChantInput } from "../../../../CommonComponents";

const SeasonTicketHolder = ({ control, name }) => {
  return (
    <div className="col form-group-constrained">
      <span>Season Ticket Holder</span>
      <div style={{ display: "flex", gap: "6px", marginTop: "2px" }}>
        <ChantInput
          control={control}
          name={`${name}.season`}
          placeholder="Section"
          tabIndex="2"
        />
        <ChantInput
          control={control}
          name={`${name}.seats`}
          placeholder="No. of seats"
          tabIndex="2"
        />
      </div>
    </div>
  );
};

export default SeasonTicketHolder;
